// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  name: "Staging",
  apiEndPoint: 'https://testing.triconah.com/hra/api/',
  marketingAPIEndpoint: 'https://api.triconah.com/staging-marketing/',
  triconPhone: '8448742661',
  triconPhoneDotFormat: '844.874.2661',
  triconSupportPhoneNumberDotFormat: '877.889.7488',
  triconSupportPhoneNumber: '8778897488',
  apiGWWorkorderEndpoint: 'https://api.triconah.com/staging-workorder/',
  mobileApp: {
    appStoreUrl: "https://apps.apple.com/us/app/tricon-homes/id1644891568",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=com.Triconresidential.TriconResidential"
  },
  identityPoolId: 'us-west-2:06e66af9-38f0-4301-b968-7e3d420ebd79',
  userPoolId: 'us-west-2_ROPPLckGI',
  clientId: '1iqatgh2fum7jc4v738pludl6',
  region: 'us-west-2',
  ddbTableName: '',
  iotHost: 'a2td36ombppzeo-ats.iot.us-west-2.amazonaws.com',
  helloSignClientId: '8022043e8b071d0bea7d77be8160f338',
  ENABLE_PURGE: true,
  marketingAssetURL: 'https://triconhomes.com/api/v1/tripod/assets',
  termsOfAgreementUrl: 'https://tricon.creativeoven.com/terms-of-agreement/',
  triconWebsiteUrl: 'https://tricon.creativeoven.com',
  applicationSubmissionSuccessUrl: 'https://staging.triconhomes.com/success/applicationsubmission/',
  redirectSignIn: "https://secure-testing.triconhomes.com/public/login",
  redirectSignOut: "https://secure-testing.triconhomes.com",
  appUrl: "https://secure-testing.triconhomes.com",
  appDomain: 'https://hra-staging.auth.us-west-2.amazoncognito.com',
  verifastOrigin: 'https://staging.verifast.app',
  // LaunchDarkly client-side ID for the Staging environment.
  launchDarklyClientId: '69697d6d67387009fca0713c',
  enableVerifastV2: true,
  MixPanelKey: '844c09c1b581dc932ac9099da9d83318',
  triconDomain: 'triconhomes',
  SmartHome: {
    MarketingUrl: "https://triconhomes.com/resources/smarthome/?utm_source=TriPOD&utm_medium=portal&utm_campaign=smart-home&utm_content=smart-home-info"
  }
};
